import { CloseCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Input, Tooltip } from 'antd';

import { PF } from '@app/pages/Warehouses/Suppliers/data';
import type { FiltersType } from '@app/pages/Warehouses/Suppliers/types';

const FILTER = `${PF}_filters`;

export const Filters: FiltersType = ({
  unsavedValues: { SearchTerm },
  onChangeSearchTerm,
  skipSearchTerm,
  onSearch,
  disabledSearch,
}) => (
  <div className={`${FILTER}_container`}>
    <Input
      addonBefore={<SearchOutlined />}
      placeholder="Введите название поставщика"
      value={SearchTerm}
      onChange={onChangeSearchTerm}
      className={`${FILTER}_search`}
      minLength={3}
      onPressEnter={onSearch}
    />
    <div className={`${FILTER}_buttons`}>
      <Button
        htmlType="reset"
        onClick={skipSearchTerm}
        className={`${FILTER}_buttons_item`}
      >
        <CloseCircleOutlined />
        Сброс
      </Button>
      <Tooltip title={disabledSearch ? 'Введите не менее 3 символов' : ''}>
        <Button
          type="primary"
          onClick={onSearch}
          className={`${FILTER}_buttons_item`}
          disabled={disabledSearch}
        >
          Показать
        </Button>
      </Tooltip>
    </div>
  </div>
);
